import {
  Badge,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaEllipsisH, FaSyncAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { formatAsNaira } from "../../helpers/helpers";
import { TransferStatus } from "../../types";
import { getTransferBadgeColor } from "./constants";
import { ThirdPartyIntegratorPayout } from "./types";

export interface ThirdPartyPayoutTableProps {
  data?: ThirdPartyIntegratorPayout[];
  isConfirmations?: boolean;
  isLoading?: boolean;
}

export const ThirdPartyPayoutTable = ({
  data,
  isConfirmations,
  isLoading,
}: ThirdPartyPayoutTableProps) => {
  const history = useHistory();

  return (
    <TableContainer>
      <Table className='border'>
        <Thead>
          <Tr>
            <Th className='border'>Date Created</Th>
            <Th className='border'>Integrator</Th>
            <Th className='border'>Business</Th>
            <Th className='border'>Status</Th>
            <Th className='border'>Payout Period</Th>
            <Th className='border'>Orders</Th>
            <Th className='border'>Amount</Th>
            <Th className='border'></Th>
          </Tr>
        </Thead>
        <Tbody>
          {isLoading && (
            <Tr>
              <Td colSpan={8} className='border'>
                <div className='w-full flex justify-center items-center min-h-[80px]'>
                  <p>
                    Loading <FaSyncAlt />
                  </p>
                </div>
              </Td>
            </Tr>
          )}
          {!data?.length && !isLoading && (
            <Tr>
              <Td colSpan={8} className='border'>
                <div className='w-full flex justify-center items-center min-h-[80px]'>
                  <p>No data available</p>
                </div>
              </Td>
            </Tr>
          )}
          {data?.map((payout) => (
            <Tr key={payout.id}>
              <Td className='border'>
                {new Date(payout.createdAt).toLocaleDateString()}
              </Td>
              <Td className='border'>
                <div>
                  <div className='font-medium'>
                    {payout.thirdPartyIntegrator.name}
                  </div>
                  <div className='text-sm text-gray-500'>
                    {payout.thirdPartyIntegrator.appId}
                  </div>
                </div>
              </Td>
              <Td className='border'>
                {payout.thirdPartyIntegrator.client.business?.name || "N/A"}
              </Td>
              <Td className='border'>
                <Badge
                  colorScheme={getTransferBadgeColor(
                    payout.transfer?.status || TransferStatus.PENDING
                  )}
                >
                  {payout.transfer?.status || TransferStatus.PENDING}
                </Badge>
              </Td>
              <Td className='border'>
                <div className='text-sm'>
                  {new Date(payout.payoutPeriodStart).toLocaleDateString()}
                  <div className='text-gray-500'>to</div>
                  {new Date(payout.payoutPeriodEnd).toLocaleDateString()}
                </div>
              </Td>
              <Td className='border'>{payout.orders.length} orders</Td>
              <Td className='border'>
                <div className='font-medium'>
                  {formatAsNaira(payout.breakdown.net)}
                </div>
                {payout.override && (
                  <div className='text-xs text-yellow-600'>Overridden</div>
                )}
              </Td>
              <Td className='border'>
                <Menu>
                  <MenuButton
                    as={IconButton}
                    aria-label='Options'
                    icon={<FaEllipsisH />}
                    variant='outline'
                  />
                  <MenuList>
                    <MenuItem
                      onClick={() =>
                        history.push(
                          `/third-party-payouts/${
                            isConfirmations ? "confirmations" : "requests"
                          }/${payout.id}`
                        )
                      }
                    >
                      View Details
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
